import React, { useEffect, useState } from "react";
import { Row, Col, CardBody, Card, Alert, Container, Input, Label, Form, FormFeedback } from "reactstrap";
import { useTranslation } from 'react-i18next';

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// action
import { registerUser, apiError, resetRegisterFlag } from "../../slices/thunks";

//redux
import { useSelector, useDispatch } from "react-redux";

import { Link, useNavigate } from "react-router-dom";

//import images
import logoLight from "../../assets/images/logo-light-vertical.png";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
import { createSelector } from "reselect";
import {appName} from "../../Components/constants/default";
import {validators} from "../../helpers/ValidatorHelper";

const Register = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [registrationComplete, setRegistrationComplete] = useState(false);
  const [passwordShow, setPasswordShow] = useState(false);
  const [passwordConfirmShow, setPasswordConfirmShow] = useState(false);

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      email: '',
      plainPassword: '',
      confirm_password: ''
    },
    validationSchema: Yup.object({
      email: Yup.string().trim().email(t("Invalid email format")).required(t("Please Enter Your Email")),
      plainPassword: validators.password(t),
      confirm_password: Yup.string()
        .oneOf([Yup.ref("plainPassword")], t("Passwords do not match"))
        .required(t("Please confirm your password")),
    }),
    onSubmit: (values) => {
      dispatch(apiError(""));
      dispatch(registerUser(values));
    }
  });

  const selectLayoutState = (state) => state.Account;
  const registerdatatype = createSelector(
    selectLayoutState,
    (account) => ({
      success: account.success,
      error: account.error,
      registrationError: account.registrationError
    })
  );

  const { error, success, registrationError } = useSelector(registerdatatype);


  useEffect(() => {
    if (success) {
      setRegistrationComplete(true);
      setTimeout(() => {
        dispatch(resetRegisterFlag());
      }, 9000);
    }
  }, [dispatch, success]);

  // Cleanup przy odmontowaniu komponentu
  useEffect(() => {
    return () => {
      dispatch(resetRegisterFlag());
    };
  }, [dispatch]);

  document.title = t('Registration') + " | " + appName;

  // Jeśli rejestracja się powiodła, pokaż komunikat o weryfikacji
  if (registrationComplete) {
    return (
      <React.Fragment>
        <ParticlesAuth>
          <div className="auth-page-content mt-lg-5">
            <Container>
              <Row>
                <Col lg={12}>
                  <div className="text-center mt-sm-5 mt-3 text-white-50">
                    <div>
                      <Link to="/" className="d-inline-block auth-logo">
                        <img src={logoLight} alt="" height="70" />
                      </Link>
                    </div>
                  </div>
                </Col>
              </Row>

              <Row className="justify-content-center">
                <Col md={8} lg={6} xl={5}>
                  <Card className="mt-4">
                    <CardBody className="p-4">
                      <div className="text-center mt-2">
                        <div className="mb-4">
                          <i className="ri-mail-send-line display-5 text-success"></i>
                        </div>
                        <h5 className="text-success mb-3">
                          {t("Registration Successful!")}
                        </h5>
                        <p className="text-muted">
                          {t("We've sent a verification email to")} <strong>{validation.values.email}</strong>
                        </p>
                        <Alert color="info" className="mt-3">
                          <i className="ri-information-line me-2"></i>
                          {t("Please check your email and click the verification link to activate your account.")}
                        </Alert>
                        <div className="mt-4">
                          <p className="mb-0 text-muted">
                            {t("Didn't receive the email?")}
                          </p>
                          <small className="text-muted">
                            {t("Check your spam folder or")}
                            <Link to="/admin/register" className="text-primary ms-1">
                              {t("try registering again")}
                            </Link>
                          </small>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                  <div className="mt-4 text-center">
                    <p className="mb-0">
                      <Link
                        to="/admin/login"
                        className="fw-semibold text-primary text-decoration-underline"
                      >
                        {t("Back to Login")}
                      </Link>
                    </p>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </ParticlesAuth>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <ParticlesAuth>
        <div className="auth-page-content mt-lg-5">
          <Container>
            <Row>
              <Col lg={12}>
                <div className="text-center mt-sm-5 mt-3 text-white-50">
                  <div>
                    <Link to="/" className="d-inline-block auth-logo">
                      <img src={logoLight} alt="" height="70" />
                    </Link>
                  </div>
                </div>
              </Col>
            </Row>

            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <Card className="mt-4">

                  <CardBody className="p-4">
                    <div className="text-center mt-2">
                      <h5 className="text-primary">
                        {t("Create New Account")}
                      </h5>
                      <p className="text-muted">
                        {t("Get your free Zagraj Mi account now")}
                      </p>
                    </div>
                    <div className="p-2 mt-4">
                      <Form
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                        className="needs-validation"
                        action="#"
                      >

                        {error && registrationError && (
                          <Alert color="danger" className="mb-3">
                            {Array.isArray(registrationError) ? (
                              // Wyświetl pierwszy błąd (zazwyczaj jest tylko jeden)
                              <div>
                                {registrationError[0]?.message === 'EMAIL_IN_USE'
                                  ? t("Email has been registered before. Please use another email address.")
                                  : registrationError[0]?.message === 'USERNAME_IN_USE' ||
                                  registrationError[0]?.message === 'USERNAME_FOR_EVENT_IN_USE'
                                    ? t("Username is already taken. Please choose another one.")
                                    : registrationError[0]?.message || t("An error occurred during registration. Please try again.")}
                              </div>
                            ) : typeof registrationError === 'string' ? (
                              <div>
                                {registrationError.includes('EMAIL_IN_USE') || registrationError.includes('email')
                                  ? t("Email has been registered before. Please use another email address.")
                                  : registrationError.includes('USERNAME')
                                    ? t("Username is already taken. Please choose another one.")
                                    : registrationError}
                              </div>
                            ) : (
                              <div>{t("An error occurred during registration. Please try again.")}</div>
                            )}
                          </Alert>
                        )}

                        <div className="mb-3">
                          <Label htmlFor="useremail" className="form-label">
                            {t("Email")} <span className="text-danger">*</span>
                          </Label>
                          <Input
                            id="email"
                            name="email"
                            bsSize="lg"
                            className="form-control"
                            placeholder={t("Enter email address")}
                            type="email"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.email || ""}
                            invalid={
                              validation.touched.email && !!validation.errors.email
                            }
                          />
                          {validation.touched.email && validation.errors.email ? (
                            <FormFeedback type="invalid">
                              <div>{validation.errors.email}</div>
                            </FormFeedback>
                          ) : null}
                        </div>

                        <div className="mb-3">
                          <Label htmlFor="userpassword" className="form-label">
                            {t("Password")} <span className="text-danger">*</span>
                          </Label>
                          <div className="position-relative auth-pass-inputgroup">
                          <Input
                            name="plainPassword"
                            bsSize="lg"
                            className="pe-5"
                            type={passwordShow ? "text" : "password"}
                            placeholder={t("Enter Password")}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.plainPassword || ""}
                            invalid={
                              validation.touched.plainPassword && !!validation.errors.plainPassword
                            }
                          />
                          {validation.touched.plainPassword && validation.errors.plainPassword ? (
                            <FormFeedback type="invalid">
                              <div>{validation.errors.plainPassword}</div>
                            </FormFeedback>
                          ) : null}
                          <button className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted" type="button" id="password-addon" onClick={() => setPasswordShow(!passwordShow)}><i className="ri-eye-fill align-middle"></i></button>
                          </div>
                        </div>

                        <div className="mb-2 position-relative auth-pass-inputgroup">
                          <Label htmlFor="confirmPassword" className="form-label">
                            {t("Confirm Password")} <span className="text-danger">*</span>
                          </Label>
                          <div className="position-relative auth-pass-inputgroup">
                          <Input
                            name="confirm_password"
                            bsSize="lg"
                            className="pe-5"
                            type={passwordConfirmShow ? "text" : "password"}
                            placeholder={t("Confirm Password")}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.confirm_password || ""}
                            invalid={
                              validation.touched.confirm_password && !!validation.errors.confirm_password
                            }
                          />
                          {validation.touched.confirm_password && validation.errors.confirm_password ? (
                            <FormFeedback type="invalid">
                              <div>{validation.errors.confirm_password}</div>
                            </FormFeedback>
                          ) : null}
                          <button className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted" type="button" id="password-addon" onClick={() => setPasswordConfirmShow(!passwordConfirmShow)}><i className="ri-eye-fill align-middle"></i></button>
                          </div>
                        </div>

                        <div className="mb-4">
                          <p className="mb-0 fs-12 text-muted fst-italic">
                            {t("By registering you agree to the Zagraj Mi")}{" "}
                            <Link
                              to="/privacy-policy"
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-primary text-decoration-underline fst-normal fw-medium"
                            >
                              {t("registerConsent.privacyPolicy")}
                            </Link>
                          </p>
                        </div>

                        <div className="mt-4">
                          <button className="btn btn-success w-100" type="submit">
                            {t("Sign Up")}
                          </button>
                        </div>
                      </Form>
                    </div>
                  </CardBody>
                </Card>
                <div className="mt-4 text-center">
                  <p className="mb-0">
                    {t("Already have an account")} ?{" "}
                    <Link
                      to="/admin/login"
                      className="fw-semibold text-primary text-decoration-underline"
                    >
                      {t("Signin")}
                    </Link>
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </ParticlesAuth>
    </React.Fragment>
  );
};

export default Register;
